module.exports = __webpack_public_path__ + "static/media/noun-wave.6371f332.svg";